import { AnyAction, Dispatch } from "@reduxjs/toolkit";
import { Editor } from "grapesjs";
import { CustomComponentSettingsFunction } from ".";
import { setGlobalProductPopupElement } from "../features/popupSlice";

import ImagePopUpV3 from "../components/ImagePopUpV3";
import PopupWrapper from "../components/PopupWrapper";
import ProductManageForm from "../components/ProductManageForm";
import { getImageArray, jsonParseSafe } from "../utils";

export const trendingProductsConfig: CustomComponentSettingsFunction = (
	editor: Editor,
	type: string,
	content?: string,
	settings?: { data: any; setData: (data: any) => void },
	extraData?: {
		dispatch?: Dispatch<AnyAction>;
	}
) => {
	editor.Components.addType(type, {
		model: {
			defaults: {
				tagName: "div",
				draggable: true,
				droppable: true,
				// Define traits (settings) here
				traits: [
					{
						type: "text", // Type of trait (input)
						label: "Title", // Label for the trait
						name: "titleText", // Name of the trait (used to get/set value)
						changeProp: true,
					},
					// banner
					{
						type: "button",
						label: "Add Banner",
						name: "bannerButton",
						text: "Add Banner",
						command(editor, trait) {
							let banner;

							const selectedComponent = editor.getSelected();
							if (selectedComponent) {
								banner =
									selectedComponent.getAttributes()[
										"data-banner"
									];
							}

							console.log("banner", banner);

							extraData?.dispatch?.(
								setGlobalProductPopupElement(
									<PopupWrapper
										onClose={() => {
											extraData?.dispatch?.(
												setGlobalProductPopupElement(
													null
												)
											);
										}}>
										<ImagePopUpV3
											onClose={() => {
												extraData?.dispatch?.(
													setGlobalProductPopupElement(
														null
													)
												);
											}}
											onUpdate={(images) => {
												const image = getImageArray(
													images?.[0]?.path
												)[0];

												console.log("images", images);

												if (image) {
													const selectedComponent =
														editor.getSelected();
													if (selectedComponent) {
														// selectedComponent.setAttributes(
														// 	{
														// 		"data-banner":
														// 			JSON.stringify(
														// 				image
														// 			),
														// 	}
														// );

														selectedComponent.addAttributes(
															{
																"data-banner":
																	JSON.stringify(
																		image
																	),
															}
														);
													}
												}

												extraData?.dispatch?.(
													setGlobalProductPopupElement(
														null
													)
												);
											}}
										/>
									</PopupWrapper>
								)
							);
						},
					},
					{
						type: "button",
						label: "Add Left Slider Products",
						name: "leftSliderButton",
						text: "Add Left Slider Products",
						command(editor, trait) {
							console.log("Button clicked", {
								editor,
								trait,
							});

							settings?.setData({
								...settings.data,
								button: "Button Clicked",
							});

							let logical: any;
							let custom: any;

							const selectedComponent = editor.getSelected();
							if (selectedComponent) {
								const customData = jsonParseSafe(
									selectedComponent.getAttributes()[
										"data-custom-left-slider"
									]
								);

								logical = customData?.logical;
								custom = customData?.custom;
							}

							// Dispatch an action to update the store
							extraData?.dispatch?.(
								setGlobalProductPopupElement(
									<PopupWrapper
										onClose={() => {
											extraData?.dispatch?.(
												setGlobalProductPopupElement(
													null
												)
											);
										}}>
										<ProductManageForm
											title="Manage Left Slider Products"
											logical={logical}
											custom={custom}
											onUpdate={(logical, custom) => {
												// setProducts({
												// 	logical:
												// 		logical || undefined,
												// 	custom: custom || [],
												// });

												const selectedComponent =
													editor.getSelected();
												if (selectedComponent) {
													selectedComponent.addAttributes(
														{
															"data-custom-left-slider":
																JSON.stringify({
																	logical,
																	custom,
																}),
														}
													);
												}

												extraData?.dispatch?.(
													setGlobalProductPopupElement(
														null
													)
												);
											}}
										/>
									</PopupWrapper>
								)
							);
						},
					},
					{
						type: "button",
						label: "Add Main Products",
						name: "mainSliderButton",
						text: "Add Main Products",
						command(editor, trait) {
							console.log("Button clicked", {
								editor,
								trait,
							});

							settings?.setData({
								...settings.data,
								button: "Button Clicked",
							});

							let logical: any;
							let custom: any;

							const selectedComponent = editor.getSelected();
							if (selectedComponent) {
								const customData = jsonParseSafe(
									selectedComponent.getAttributes()[
										"data-custom-main-slider"
									]
								);

								logical = customData?.logical;
								custom = customData?.custom;
							}

							// Dispatch an action to update the store
							extraData?.dispatch?.(
								setGlobalProductPopupElement(
									<PopupWrapper
										onClose={() => {
											extraData?.dispatch?.(
												setGlobalProductPopupElement(
													null
												)
											);
										}}>
										<ProductManageForm
											title="Manage Main Products"
											logical={logical}
											custom={custom}
											onUpdate={(logical, custom) => {
												// setProducts({
												// 	logical:
												// 		logical || undefined,
												// 	custom: custom || [],
												// });

												const selectedComponent =
													editor.getSelected();
												if (selectedComponent) {
													selectedComponent.addAttributes(
														{
															"data-custom-main-slider":
																JSON.stringify({
																	logical,
																	custom,
																}),
														}
													);
												}

												extraData?.dispatch?.(
													setGlobalProductPopupElement(
														null
													)
												);
											}}
										/>
									</PopupWrapper>
								)
							);
						},
					},
					{
						type: "text",
						label: "Search",
						name: "search",
						placeholder: "Search...",
						changeProp: false,
						value: "Product",
						command(editor, trait) {
							console.log("Search clicked", {
								editor,
								trait,
							});
						},
					},
				],
				// Define the initial content or data for the component
				// content: data.content,
			},
			init() {
				// this.on("change:titleText", this.handleCustomTextChange);
				this.listenTo(
					this,
					"change:titleText",
					this.handleCustomTextChange
				);
			},
			handleCustomTextChange() {
				const newValue = this.get("titleText");
				// this.set("content", newValue); // Update the content dynamically based on the trait value
				console.log("newValue", newValue);
			},
		},
		view: {
			// Define how the component should render in the canvas
			onRender({ model }) {
				const _content = model.get("content");
				this.el.innerHTML =
					_content || content || "This is a custom component";
			},
		},
	});
};

export default () => <></>;
